export default {
  createItem: {
    server: '/shifts/measuring-points/{measuringPointId}',
    method: 'post',
  },
  getItems: {
    server: '/shifts/measuring-points/{measuringPointId}',
    method: 'get',
  },
  deleteItem: {
    server: '/shifts/measuring-points/{measuringPointId}/{shiftId}',
    method: 'delete',
  },
};
